import {SessionService} from './session';
import {BackendModule} from '../modules/backend.module';
import {Injectable} from '@angular/core';

interface Banner {
  linkHref: string;
  image: string;
  name: string;
}

@Injectable()
export class MishiService {
  homeBanner: Banner;
  searchBanner: Banner;
  intervalId: number;

  constructor(
    public backendModule: BackendModule,
    public sessionService: SessionService,
  ) {
  }

  ngOnDestroy() {
    this.stopIntervalForHomeBanner();
  }


  loadBanners(): Promise<[Banner, Banner]> {
    const userId = this.sessionService.user.id;

    return Promise.all([
      this.loadHomeBanner(),
      this.backendModule
        .getAPI(`mishi/serve?user_id=${userId}&size=350x110&placement=app_search_class_page`, {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        })
        .toPromise()
        .then((res: any) => {
          console.log('Serve', res);
          this.searchBanner = {
            linkHref: res.link_href,
            image: res.image_src,
            name: ''
          };

          return this.searchBanner;
        })
    ]);
  }

  loadSearchBanner(): Promise<Banner> {
    const userId = this.sessionService.user.id;

    return this.backendModule
      .getAPI(`mishi/serve?user_id=${userId}&size=350x110&placement=app_search_class_page`, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
      .toPromise()
      .then((res: any) => {
        this.searchBanner = {
          linkHref: res.link_href,
          image: res.image_src,
          name: ''
        };

        return this.searchBanner;
      });
  }

  stopIntervalForHomeBanner() {
    console.log('=> MishiService: stopIntervalForHomeBanner');
    clearInterval(this.intervalId);
  }

  startIntervalForHomeBanner() {
    const time = 1000 * 60 * 30; // 30 minutes

    console.log('=> MishiService: startIntervalForHomeBanner', new Date().toISOString());
    this.loadHomeBanner();

    this.intervalId = setInterval(() => {
      console.log('=> MishiService: startIntervalForHomeBanner', new Date().toISOString());
      this.loadHomeBanner();
    }, time);
  }

  startIntervalForHomeBannerTest() {
    const time = 1000 * 5;

    let i = 0;

    this.loadHomeBannerTest(i).then((banner) => {
      this.homeBanner = banner as Banner;
    });

    this.intervalId = setInterval(() => {
      console.log('=> loadHomeBanner: ', new Date().toISOString());

      i++;

      this.loadHomeBannerTest(i).then((banner) => {
        this.homeBanner = banner as Banner;
      });
    }, time);
  }

  loadHomeBannerTest(i: number): Promise<Banner> {
    const images = [
      "https://www.fitpass.com/assets/stores/shared/gift-fitpass-0c52712007bce9cd42328b2f91272e61cb11a6d7c33d082d78f184291fee4b34.jpg",
      "https://mail.fitpass.mx/sendy/uploads/1747705236.png"
    ]

    return new Promise((resolve) => {
        resolve({
          linkHref: 'https://www.fitpass.com',
          image: images[i % 2 ? 0 : 1],
          name: ''
        });
    });
  }

  loadHomeBanner(): Promise<Banner> {
    const userId = this.sessionService.user.id;

    return this.backendModule
      .getAPI(`mishi/serve?user_id=${userId}&size=400x100&placement=app_home_page`, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
      .toPromise()
      .then((res: any) => {
        this.homeBanner = {
          linkHref: res.link_href,
          image: res.image_src,
          name: ''
        };

        return this.homeBanner;
      });
  }

}



// WEBPACK FOOTER //
// ./src/services/mishi.ts